import RestClient from './../../service/rest-client';
import {Signal} from 'signals';

class Service {
    event = {
        onFetchCountriesStatus: new Signal()
    };
    // start accounts without sent shipment code
    fetchCountries() {
        RestClient.isSessionActive();
        var limit = 500;

        var queryParams = [`limit=${ limit }`];

        var urlRequestEndPointString = "";

        urlRequestEndPointString = "/countries" + "?";

        var urlRequestTemplate = urlRequestEndPointString + queryParams.join("&");

        RestClient.getRequest(urlRequestTemplate,"").then((data) => {
                this.event.onFetchCountriesStatus.dispatch(data);
        }).catch((error) => {

        });
    }

} export default new Service();
